var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentVariant)?_c('ProductComparePrice',{staticClass:"relative",attrs:{"price":_vm.currentVariant.price,"compare-at-price":_vm.currentVariant.compareAtPrice,"price-range-max":_vm.priceRangeMax,"price-range-min":_vm.priceRangeMin}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }